import React from 'react'
import './Whyui.css'
import w1 from '../Images/w1.png';
import w2 from '../Images/w2.png';
import w3 from '../Images/w3.png';
import w4 from '../Images/w4.png';
import w5 from '../Images/w5.png';
import w6 from '../Images/w6.png';
import why1 from '../Images/why1.svg';
import why2 from '../Images/why2.svg';
import why3 from '../Images/why3.svg';
import why4 from '../Images/why4.svg';
import why5 from '../Images/why5.svg';
import why6 from '../Images/why6.svg';
const Whyui = () => {
    const imgdata = [
        {
            id: 1,
            icon: why1,
            heading: "User-First Approach",
            text: "We conduct in-depth research, competitor analysis, and usability testing to ensure every design choice is data-backed and user-focused. Our goal is to craft experiences that are intuitive and enjoyable for your audience."
        },
        {
            id: 2,
            icon: why2,
            heading: "Conversion-Focused Design",
            text: "Beyond great visuals, we prioritize business impact by designing journeys that boost engagement, sign-ups, sales, and long-term retention. Every interaction is optimized to deliver measurable results."
        },
        {
            id: 3,
            icon: why3,
            heading: "Scalable Design Systems",
            text: "We build flexible and consistent design systems that adapt across platforms, ensuring seamless experiences for websites, mobile apps, and enterprise-level software. This keeps your brand identity unified and future-proof."
        },

    ]
    const imgdata2 = [
        {
            id: 4,
            icon: why4,
            heading: "Cross-Industry Expertise",
            text: "With proven experience in SaaS, eCommerce, fintech, gaming, healthcare, and more, we understand the unique challenges of different industries and tailor our solutions accordingly."
        },
        {
            id: 5,
            icon: why5,
            heading: "Continuous Optimization",
            text: "BastionEx work doesn’t end at delivery. We track performance, gather user feedback, and refine designs to maximize usability, engagement, and ROI over time."
        },
        // {
        //     id: 6,
        //     icon: why6,
        //     heading: "Strong Design Culture",
        //     text: "We foster a strong design culture within our talented team, resulting in the creation of memorable and amazing designs. Our designers not only bring creative expertise but also a dedication to reflecting your unique brand personality. Through our designs, we help you stand out from the competition and leave a lasting impression on your audience."
        // }
    ]
    return (
        <div id='whyui'>
            <div className="section">
                <div className="container">
                    <div className="whyLeft">
                        {/* <h3 className="blueheading">
                            Why choose us
                        </h3> */}
                        <h1 className="heading">
                            How We Work On Custom Website Design Services
                        </h1>
                        <p className="newpara">
                          Our team of UX strategists, product designers, and interface experts goes beyond aesthetics—we create digital products that are functional, user-friendly, and measurable in performance. Every design decision is guided by research, creativity, and a strong focus on business goals.
                        </p>
                    </div>
                    <div className="whyRight">
                        <div className="imgbox1">
                            {imgdata.map((item) => {
                                return (
                                    <div key={item.id} className={`imgbox imgboxx${item.id}`}>
                                        <div>
                                            <div className="iconbox">
                                                <img src={item.icon} alt="" className='imgicon' />
                                            </div>
                                            <h3 className='imgboxheading'>{item.heading}</h3>
                                        </div>
                                        <p className='imgboxpara'>{item.text}</p>
                                    </div>
                                )
                            })}
                            {/* <img src={w1} alt="" />
                            <img src={w2} alt="" />
                            <img src={w3} alt="" /> */}
                        </div>
                        <div className="imgbox2">
                            {imgdata2.map((item) => {
                                return (
                                    <div key={item.id} className={`imgbox imgboxx${item.id}`}>
                                        <div>
                                            <div className="iconbox">
                                                <img src={item.icon} alt="" className='imgicon' />
                                            </div>
                                            <h3 className='imgboxheading'>{item.heading}</h3>
                                        </div>
                                        <p className='imgboxpara'>{item.text}</p>
                                    </div>
                                )
                            })}
                            {/* <img src={w4} alt="" />
                            <img src={w5} alt="" />
                            <img src={w6} alt="" /> */}
                        </div>



                    </div>
                </div>
            </div>
        </div>
    )
}

export default Whyui